import { Grid } from "@mui/material";
import { useEffect, useMemo, useState } from "react";

import Modal from "../../components/Modal";
import Helpers from "../../commons/helpers";
import useStrings from "../../hooks/useStrings";
import FormField from "../../components/FormField";
import Typography from "../../components/Typography";
import CodeNameService from "../../services/common/codeName.service";

import { IDataCodename } from "./edit";
import { IRecordCodename } from "./list";
import { Mode, Status } from "../../constants/enums";
import { useCommonComponentContext } from "../../providers/CommonComponentProvider";



const ModalCreateEditCodename = (props: {
    mode: Mode,
    group?: string,
    openModal?: boolean;
    dataDetailCodename?: IDataCodename,

    onClose?: () => void,
    onCallBack: (data: IRecordCodename, isCreate: boolean) => void,
}) => {

    const Strings = useStrings();
    const {
        userInfo,
        serviceCode,
        onError,
        onSuccess,
        onShowLoading,
        onHideLoading,
    } = useCommonComponentContext();

    const [dataCodeName, setDataCodeName] = useState<IDataCodename>({} as IDataCodename);

    const nameModal = useMemo(() => {
        if (Helpers.isNullOrEmpty(dataCodeName?.id)) {
            return Strings.Common.ADD_NEW;
        } else {
            return (dataCodeName?.status === Status.Inactive)
                ? Strings.Common.VIEW_DETAIL
                : Strings.Common.UPDATE
        }
    }, [Strings, dataCodeName?.id, dataCodeName?.status]);

    useEffect(() => {
        setDataCodeName(props.dataDetailCodename);
    }, [props.dataDetailCodename]);

    const handleOnActionByModal = async () => {
        let isChecked = true;
        let dataTemp: any = { ...dataCodeName };

        if (Helpers.isNullOrEmpty(dataTemp?.["code"]?.value)) {
            isChecked = false;
            dataTemp["code"] = { error: Strings.Common.REQUIRED };
        }
        if (Helpers.isNullOrEmpty(dataTemp?.["name"]?.value)) {
            isChecked = false;
            dataTemp["name"] = { error: Strings.Common.REQUIRED };
        }

        if (!isChecked) {
            setDataCodeName(dataTemp);
        } else {
            try {
                onShowLoading();

                const orgId = userInfo?.userProfile?.organizationId || "0";

                const dataSubmit: any = {
                    group: props.group,
                    code: dataTemp?.code?.value,
                    name: dataTemp?.name?.value,
                    shortName: dataTemp?.shortName?.value,
                    organizationId: dataTemp?.organizationId || orgId,
                    serviceCode: dataTemp?.serviceCode || serviceCode,
                };

                if (Helpers.isNullOrEmpty(dataTemp?.id)) {
                    //create                
                    const result = await CodeNameService.create(dataSubmit);

                    if (result.statusCode === 200) {
                        setDataCodeName({} as IDataCodename);

                        onSuccess(Strings.CODE_NAME.CREATE_SUCCESS);

                        props.onCallBack({ ...result.result }, true);
                    }
                } else {
                    //update
                    const result = await CodeNameService.update({
                        ...dataSubmit,
                        id: dataTemp?.id,
                        updateTime: dataTemp?.updateTime,
                    });

                    if (result.statusCode === 200) {
                        setDataCodeName({} as IDataCodename);

                        onSuccess(Strings.CODE_NAME.UPDATE_SUCCESS);

                        props.onCallBack({ ...result.result }, false);
                    }
                }

                onHideLoading();
            } catch (error) {
                onHideLoading();
                const e = Helpers.renderExceptionError(error);
                onError(e);
            }
        }
    }
    // #region Modal
    return (
        <>
            <Modal
                fullWidth
                maxWidth="sm"
                visible={props.openModal || false}
                hasActionButton={dataCodeName?.status !== Status.Inactive}
                onAction={() => {
                    handleOnActionByModal();
                }}
                onClose={() => {
                    setDataCodeName({} as IDataCodename);
                    props.onClose();
                }}
            >
                <Grid container spacing={3} p={2}>
                    <Grid item xs={12}>
                        <Typography variant="h5">
                            {nameModal}
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <FormField
                            required
                            maxLength={255}
                            mode={props.mode}
                            label={Strings.CODE_NAME.CODE}
                            placeholder={Strings.CODE_NAME.ENTER_CODE}
                            errorMessage={dataCodeName?.code?.error}
                            defaultValue={dataCodeName?.code?.value || ""}
                            disabled={!Helpers.isNullOrEmpty(dataCodeName?.id)}
                            onBlur={(value) => {
                                setDataCodeName({
                                    ...dataCodeName,
                                    code: { value }
                                });
                            }}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <FormField
                            required
                            maxLength={255}
                            mode={props.mode}
                            label={Strings.CODE_NAME.NAME}
                            placeholder={Strings.CODE_NAME.ENTER_NAME}
                            errorMessage={dataCodeName?.name?.error}
                            defaultValue={dataCodeName?.name?.value || ""}
                            disabled={dataCodeName?.status === Status.Inactive}
                            onBlur={(value) => {
                                setDataCodeName({
                                    ...dataCodeName,
                                    name: { value }
                                });
                            }}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <FormField
                            maxLength={255}
                            mode={props.mode}
                            label={Strings.CODE_NAME.SHORT_NAME}
                            placeholder={Strings.CODE_NAME.ENTER_SHORT_NAME}
                            defaultValue={dataCodeName?.shortName?.value || ""}
                            disabled={dataCodeName?.status === Status.Inactive}
                            onBlur={(value) => {
                                setDataCodeName({
                                    ...dataCodeName,
                                    shortName: { value }
                                });
                            }}
                        />
                    </Grid>
                </Grid>
            </Modal>
        </>
    )

    // #endregion
};

export default ModalCreateEditCodename;